import { $ } from '../core/text.js';

/* ══════════ Konfetti (Pixel) ══════════ */
export function confetti() {
  const cv = $('#confetti');
  cv.style.display = 'block'; cv.width = innerWidth; cv.height = innerHeight;
  const ctx = cv.getContext('2d');
  const colors = ['#b79cf0', '#ff9fb0', '#ffd67e', '#9fdcb4', '#9fcdf0', '#f6e0f5'];
  const bits = Array.from({ length: 130 }, () => ({
    x: Math.random() * cv.width, y: -20 - Math.random() * cv.height * 0.5,
    r: 6 + Math.floor(Math.random() * 4) * 2, c: colors[Math.floor(Math.random() * colors.length)],
    vx: (Math.random() - .5) * 2.2, vy: 2 + Math.random() * 3, rot: 0, vr: 0,
  }));
  const t0 = Date.now();
  (function frame() {
    ctx.clearRect(0, 0, cv.width, cv.height);
    for (const b of bits) { b.x += b.vx; b.y += b.vy; b.vy += 0.03; ctx.fillStyle = b.c; ctx.fillRect(Math.round(b.x), Math.round(b.y), b.r, b.r); }
    if (Date.now() - t0 < 3200) requestAnimationFrame(frame);
    else { ctx.clearRect(0, 0, cv.width, cv.height); cv.style.display = 'none'; }
  })();
}

